module.exports = __webpack_public_path__ + "img/d909fad.png";